import React from 'react'
import propTypes from 'prop-types'
import {isEqual} from 'lodash'
import {textNeedsTranslating} from 'helpers/language'

class TranslatedText extends React.Component {

  componentDidMount() {
    this.checkText()
  }

  componentDidUpdate(prevProps) {
    const {targetLanguage, children} = this.props
    const {targetLanguage: prevTargetLanguage, children: prevChildren} = prevProps

    if (!isEqual(targetLanguage, prevTargetLanguage) ||
        !isEqual(children, prevChildren)) {

      this.checkText()
    }
  }

  checkText = () => {
    const {user, children, languageMap, targetLanguage, onTranslate} = this.props

    if (textNeedsTranslating(user, children, languageMap, targetLanguage))
      onTranslate(children)
  }

  render() {
    const {translation} = this.props
    return <span>{translation}</span>
  }
}

TranslatedText.propTypes = {
  user: propTypes.object.isRequired,
  children: propTypes.string.isRequired,
  dataTokens: propTypes.array,
  showOriginal: propTypes.bool,

  // Provided by connect
  translation: propTypes.string.isRequired,
  languageMap: propTypes.object,
  targetLanguage: propTypes.string.isRequired,
  onTranslate: propTypes.func.isRequired,
}

export default TranslatedText
